import Alpine from 'alpinejs'

import { isElementInViewport, loadPartial } from './ajaxUtils'
import { createVodCollectionCarousel2 } from './carousels2'
import timer from './timer'

/**
 * Lazily loads collection when it is in viewport.
 *
 * @param {} itemId - collection id
 * @param {} url - url for lazy loading
 */
const lazyCollection = (itemId, url) => ({
  loaded: false,
  itemId: itemId,

  init() {
    this.$nextTick(() => {
      if (isElementInViewport(this.$el)) {
        this.$dispatch('scrolled-into-view', { id: itemId })
      }
    })
  },

  loadInViewport: {
    ['@scrolled-into-view.window']() {
      if (!this.loaded && this.$event.detail.id === itemId) {
        this.loaded = true
        loadPartial(url, this.$el).then(() => {
          createVodCollectionCarousel2(this.$el)
        })
      }
    },
    ['@scroll.window']() {
      if (!this.loaded && isElementInViewport(this.$el)) {
        this.$dispatch('scrolled-into-view', { id: itemId })
      }
    },
    ['@collections-updated.window']() {
      if (!this.loaded && isElementInViewport(this.$el)) {
        this.$dispatch('scrolled-into-view', { id: itemId })
      }
    }
  }
})

Alpine.data('lazyCollection', lazyCollection)

// add/remove css class to element if children element is clamped
const addClampedClass = parentEl => {
  const el = parentEl.querySelector('.long-text-lc__text')
  parentEl.classList.toggle(
    'long-text-lc--clamped',
    el.scrollHeight > el.clientHeight
  )
}

//long-text-lc
Alpine.data('longTextLc', () => ({
  init() {
    const el = this.$root
    addClampedClass(el)
    const resizeObserver = new ResizeObserver(() => {
      addClampedClass(el)
    })
    resizeObserver.observe(el.querySelector('.long-text-lc__text'))
  },
  open() {
    this.$root.classList.add('long-text-lc--expanded')
    this.$root.classList.remove('long-text-lc--clamped')
  },
  close() {
    this.$root.classList.remove('long-text-lc--expanded')
    addClampedClass(this.$root)
  }
}))

window.components = {
  timer
}

window.Alpine = Alpine
Alpine.start()
